import { Link } from 'react-router-dom';
import { usePageTitle } from '@/hooks/usePageTitle';

export function NotFoundPage() {
  usePageTitle('Not found');
  return (
    <div className="min-h-screen flex items-center justify-center bg-bb-bg p-4">
      <div className="bg-white  shadow-sm border border-bb-lilac/40 p-8 max-w-md text-center">
        <div className="text-6xl font-bold text-bb-navy mb-2">404</div>
        <h1 className="text-lg font-semibold text-slate-800 mb-1">Page not found</h1>
        <p className="text-sm text-slate-500 mb-4">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link to="/" className="text-bb-navy hover:underline">
          Go home
        </Link>
      </div>
    </div>
  );
}

export function ForbiddenPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bb-bg p-4">
      <div className="bg-white  shadow-sm border border-bb-lilac/40 p-8 max-w-md text-center">
        <div className="text-6xl font-bold text-bb-navy mb-2">403</div>
        <h1 className="text-lg font-semibold text-slate-800 mb-1">Access denied</h1>
        <p className="text-sm text-slate-500 mb-4">
          You don't have permission to view this page.
        </p>
        <Link to="/" className="text-bb-navy hover:underline">
          Go home
        </Link>
      </div>
    </div>
  );
}
